
import Icon from "../../../Icon";

export default function LessonMenu({ setOpenSwap, setOpenChange}) {



    
    const menu = [
    {
        icon: "swap",
        text: "Swap lessons",
            click: () => {

                setOpenSwap(true)
            },
    },
    {
        icon: "edit",
        text: "Change lesson",
        click: () => setOpenChange(true),
    },
    ];
    return (
      <div className="p-1 bg-white border-gray-300 border-1 rounded-sm shadow-2xl">
            {menu.map((item,index) => (<DrawMenu key={index} item={item} />))}
         
      </div>
    );
}

function DrawMenu({ item }) {
    const { icon, text, click } = item;
  return (
    <div
      className="p-3 hover:bg-gray-100 cursor-pointer flex gap-2"
      onClick={click}
    >
      <div>
        <Icon name={icon} />
      </div>
      <div>{text}</div>
    </div>
  );
}
